import '../styles/statics.css';
import React from "react";

export default function About() {
    return <div className="about-text">
        <p style={{ margin: '0' }}>Это курсовая работа, сделанная студентом третьего курса</p>
        <p style={{ margin: '0' }}>с какой-то там фамилией, внизу страницы инициалы.</p>
        <p style={{ margin: '0' }}>В планах поиск и возможность кидать</p>
        <p style={{ margin: '0' }}>другим свои полки для флекса.</p>
        <p style={{ margin: '0' }}>Но самое главное это</p>
        <p style={{ margin: '0' }}>приключение спря</p>
        <p style={{ margin: '0' }}>танное в это</p>
        <p style={{ margin: '0' }}>м сайте.</p>
        <img src="/sona.png" alt=""/>
    </div>;
}